module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318845.91bda928.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318845.pdf
// module id = 845
// module chunks = 0